import React, { useState } from 'react';
import {
	Alert,
	Box,
	Button,
	Checkbox,
	FormControlLabel,
	Link,
	Stack,
	TextField,
	Typography,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import LegalPageLayout from './LegalPageLayout';
import {
	SMS_OPT_IN,
	SMS_PRIVACY_URL,
	SMS_TERMS_URL,
} from '../../Shared/smsOptInCopy';

/**
 * Public A2P/TCPA opt-in disclosure page (Twilio Message Flow reference).
 * Managers complete the live form in Settings > SMS after signing in.
 */
const SmsOptIn = () => {
	const [phone, setPhone] = useState('');
	const [consent, setConsent] = useState(false);
	const [submitted, setSubmitted] = useState(false);

	const handleSubmit = (event) => {
		event.preventDefault();
		if (!phone.trim() || !consent) {
			return;
		}
		setSubmitted(true);
	};

	return (
		<LegalPageLayout title="SMS alerts opt-in">
			<Stack spacing={2.5} component="form" onSubmit={handleSubmit} noValidate>
				<Typography variant="body1">{SMS_OPT_IN.purpose}</Typography>
				<Typography variant="body2" color="text.secondary">
					{SMS_OPT_IN.frequency}
				</Typography>
				<Typography variant="body2" color="text.secondary">
					{SMS_OPT_IN.rates} {SMS_OPT_IN.helpStop}
				</Typography>

				<Alert severity="info">
					Organization managers enable this for real after signing in at{' '}
					<strong>Settings &gt; SMS alerts</strong>. This public page documents
					the same consent language for carriers and reviewers.
				</Alert>

				<TextField
					label="Mobile phone number"
					value={phone}
					onChange={(e) => {
						setPhone(e.target.value);
						setConsent(false);
						setSubmitted(false);
					}}
					fullWidth
					required
					placeholder="+15551234567"
					helperText="E.164 preferred (e.g. +15551234567)"
					autoComplete="tel"
				/>

				<FormControlLabel
					sx={{ alignItems: 'flex-start', m: 0 }}
					control={
						<Checkbox
							checked={consent}
							onChange={(e) => setConsent(e.target.checked)}
							sx={{ pt: 0.25 }}
						/>
					}
					label={
						<Typography variant="body2">{SMS_OPT_IN.consentLabel}</Typography>
					}
				/>

				<Typography variant="body2" color="text.secondary">
					<Link href={SMS_TERMS_URL} target="_blank" rel="noopener noreferrer">
						Terms of Service
					</Link>
					{' \u00b7 '}
					<Link
						href={SMS_PRIVACY_URL}
						target="_blank"
						rel="noopener noreferrer"
					>
						Privacy Policy
					</Link>
				</Typography>

				<Box>
					<Button
						type="submit"
						variant="contained"
						disabled={!phone.trim() || !consent}
					>
						{SMS_OPT_IN.submitLabel}
					</Button>
				</Box>

				{submitted ? (
					<Alert severity="success">
						To finish enabling alerts on your account,{' '}
						<Link component={RouterLink} to="/login">
							sign in
						</Link>{' '}
						and open Settings &gt; SMS alerts, then save your phone with the
						same consent.
					</Alert>
				) : null}
			</Stack>
		</LegalPageLayout>
	);
};

export default SmsOptIn;
